import { Grid, Stack } from '@mui/material';
import { WsTypography, WsTypoVariants, WsTypoColors, WsButton } from 'wisestep-base';

type JobTypewithCountProps = {
  text: string;
  icon: React.ReactElement;
  count?: string | number;
  onClick?: () => void;
  optionalTextColor?: WsTypoColors;
};
const JobCountCard = ({
  icon,
  text = '',
  count = '',
  onClick = () => {},
  optionalTextColor = WsTypoColors.SECONDARY,
}: JobTypewithCountProps) => {
  return (
    <Grid item xs={3}>
      <WsButton variant="text">
        <Stack direction="row" spacing={1}>
          {icon}
          <WsTypography
            variant={WsTypoVariants.BODY1}
            color={WsTypoColors.BLACK}
            cursor="pointer"
            bold={true}
          >
            {count}
          </WsTypography>
          <WsTypography
            onClick={onClick}
            variant={WsTypoVariants.BODY1}
            color={optionalTextColor}
            opacity={true}
            cursor="pointer"
            bold={true}
          >
            {text}
          </WsTypography>
        </Stack>
      </WsButton>
    </Grid>
  );
};
export default JobCountCard;
